import { take, map } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@modules/authentication';

@Injectable()
export class IsUserLogged {

    private authService = inject(AuthenticationService);
    private router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        return this.authService.subject.pipe(
            take(1),
            map(isAuthenticated => {
                if (isAuthenticated) {
                    return true;
                } else {
                    // L'utilisateur n'est pas connecté, on redirige vers le login
                    console.warn('User is not logged in, redirecting to login.');
                    this.authService.goToLogin(state);
                    return false;
                }
            })
        );
    }
}
